import React from 'react'
import { useContainerWidth, colors } from '@fs/zion-ui'
import { TextAndIconButton, useSquishyButton } from '@fs/zion-ui/quarks-authorized-use-only'
import { css } from '@linaria/core'
import { useTranslation } from 'react-i18next'
import { HelpAi } from '@fs/zion-icon'

const buttonCss = css`
  position: sticky;
  bottom: 60px;
  inset-inline-end: 60px;
  align-self: flex-end;
  z-index: 2;
  margin-bottom: 20px;

  padding: 13px 20px;
  max-width: 100%;
  text-transform: uppercase;
  height: 44px;
  border-radius: 2em;
  min-height: 44px;

  background: ${colors.gray100};
  color: ${colors.gray00};
  font-size: 16px;
  &:hover:not([aria-disabled='true']):not(:active) {
    background: ${colors.gray70};
    transform: scale(var(--button-scale, 1.06));
  }

  // Only show outline and scale on keyboard focus
  &:focus-visible {
    outline: 3px solid ${colors.gray90};
    transform: scale(var(--button-scale, 1.06));
    background: ${colors.gray70};
  }

  &:active {
    background: ${colors.gray100} !important;
  }

  transition:
    background-color 0.3s,
    transform 0.3s;
`

export default function ChatbotLaunchPillButton({ handleClick, overlay }) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const buttonScale = useSquishyButton(overlay.targetRef)

  return (
    <TextAndIconButton
      className={buttonCss}
      ref={overlay.targetRef}
      title={t('help-overlay-button.text', 'Get Help')}
      emphasis="high"
      Icon={HelpAi}
      onClick={handleClick}
      size={atWidth({ sm: 'md', md: 'lg' })}
      data-testid="help-overlay-lower-left"
      linkName="LIHP-USA:help-chat-bot"
      style={{ '--button-scale': buttonScale }}
    >
      {t('help-overlay-button.text', 'Get Help')}
    </TextAndIconButton>
  )
}
